import config from 'constants/config'
import { resolveLocalizedConfigValue } from 'constants/config/resolveLocalizedConfigValue'
import SearchHeader from 'components/Search/SearchHeader/SearchHeader'
import PromptCardSelector from 'components/Common/StickyPromptCard/PromptCardSelector'
import ErrorBoundary from 'components/Common/ErrorBoundary/ErrorBoundary'
import { useIntl } from 'react-intl'

function HotelSearchFullScreenPage() {
  const intl = useIntl()
  return (
    <>
      <SearchHeader title={resolveLocalizedConfigValue(intl, config.searchFormSection.title)} />
      <ErrorBoundary fallback={null}>
        <PromptCardSelector tripReengagement />
      </ErrorBoundary>
    </>
  )
}

export default HotelSearchFullScreenPage
